/**
 * Deposit Method Model
 */

define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');
    var urlUtil = require('util/url.util');
    var config = require('config');
    var server = require('server');
    var DepositMethodModel = require('portlets/cashier/deposit/deposit.method.model');

    module.exports = DepositMethodModel.extend({

        handleSpecialPmsDeposit: function(request, account) {
            switch (this.get('code')) {
                case 'DotpayBlik':
                    this.handleDotpayBlikDeposit(request);
                    break;
                case 'DotpayCard':
                    this.handleDotpayCardDeposit(request);
                    break;
                /* TotalCasino changes */
                case 'P24Card':
                    this.handleP24CardDeposit(request);
                    break;
                /* TotalCasino changes */
                case 'DotpayBankTransfer':
                    this.handleDotpayBankTransferDeposit(request);
                    break;
                case 'PayPalViaSC':
                    this.handlePayPalViaSC(request, account);
                    break;
            }
        },

        getSpecificField9ByField2: function(targetField2) {
            const accounts = this.get('account') || [];

            return accounts.find((acc) => acc.specificParams?.field2 === targetField2)?.specificParams?.field9;
        },

        /* TotalCasino changes */
        handleP24CardDeposit: function(request) {
            const { specificParams } = request;
            const hasRequestField2 = specificParams?.field2;
            const field9IsPresent = this.getSpecificField9ByField2(hasRequestField2);

            delete request.accountCode;

            specificParams.field3 = specificParams.field3 || 'false';

            if (hasRequestField2 === 'add') {
                delete specificParams.field2;
            } else if (hasRequestField2) {
                delete specificParams.field3;

                if(field9IsPresent) {
                    specificParams.field9 = field9IsPresent;
                }
            }
        },
        /* TotalCasino changes */

        setBackgroundPage: function() {
            if (Playtech.Variables?.pageInPopupUrls?.includes(location.pathname)) {
                sessionStorage.setItem('depositBackgroundPage', Playtech.API?.page?.popupBackgroundPagePath || '/');
            }
        },

        deposit: function(data) {
            var request = this.getRequestData(data);
            var clientTypeByURL = urlUtil.getLocationParameterByName('clientType');
            var clientPlatformByURL = urlUtil.getLocationParameterByName('clientPlatform');
            var account = _.findWhere(this.get('account'), { code: data.accountCode });

            if (this.get('isSubMethod')) {
                request.methodCode = this.get('methodCode');
                request.subMethodsCodes = [this.get('code')];
            } else if (this.get('code') === 'VisaCheckout') {
                request.methodCode = _.findWhere(this.get('account'), { code: data.accountCode }).pmCode;
            }

            request = this.getBackUrls(request, 'deposit', this.get('reDirectType'));

            // Non-generic method
            if (!this.get('isGeneric')) {
                request.accountCode = data.accountCode;
            }

            request.specificParams = _.extend(
                request.specificParams,
                _.omit(
                    data,
                    this.confirmedFields,
                    ['accountCode', 'amount', 'storedAccountId', 'promoCode']
                )
            );

            // additional params
            _.extend(request, _.pick(data, this.confirmedFields));

            if (clientTypeByURL) {
                request.clienttype = clientTypeByURL;
            } else if (config.get('cashierClientType')) {
                request.clienttype = config.get('cashierClientType');
            }

            if (clientPlatformByURL) {
                request.clientplatform = clientPlatformByURL;
            }

            if (!config.get('sendCashierMessagesToGS')) {
                request.xNoPlayermessageToGs = true;
            }

            if (account && account.storeCardConfirmationRequired) {
                request.storeCardConfirmed = true;
            }

            this.handleSpecialPmsDeposit(request, account);

            this.setBackgroundPage(); /* TotalCasino changes */
            return server.send(request);
        },
    });
});
